import React, {createContext, useCallback, useContext, useEffect, useState} from "react";
import {Nsuer} from "../web3/nsuer";
import {useWallet} from "use-wallet";
import Web3 from "web3";
import {Contrcts} from "../web3/contrcts";
import {HttpServer} from "../net/http_server";
import WalletConnect from "@walletconnect/client";
import {NSURE, TokenInterFace, USDT} from "../web3/token.config";
import {useWait} from "../utils/wait_fn";
import BigNumber from "bignumber.js";
import * as https from "https";


let current: number = 0;
export const Web3Provider: React.FC = ({children}) => {

    const [nsuer, setNsuer] = useState<any>();
    const {ethereum, chainId, getBlockNumber, connector, account} = useWallet();

    const [data, setData] = useState({
        block: current, token: {
            usdt: new BigNumber(0),
            eth: new BigNumber(0),
            btc: new BigNumber(0),
            nsure: new BigNumber(0),
            usd: new BigNumber(0),
        }
    });

    const callBack = useCallback(async (nsuer: Nsuer) => {
        if (!account) return;
        const latestBlockNumber = await nsuer.web3.eth.getBlockNumber();

        if (current !== latestBlockNumber) {
            let token: any = await tokenList(nsuer.tokenMap, nsuer.web3, account);
            setData(
                {
                    block: latestBlockNumber,
                    token,
                }
            );
            current = latestBlockNumber;
        }
    }, [ethereum, getBlockNumber, setData]);


    useEffect(() => {
            if (!ethereum) return;
            let _nsuer = new Nsuer(ethereum, chainId || 0, {connector});
            setNsuer(_nsuer);
            HttpServer.account = account;


            callBack(_nsuer);
            const interval = setInterval(async () => {
                callBack(_nsuer);
            }, 3000);

            return () => clearInterval(interval)
        }, [ethereum],
    );

    return (
        <web3Context.Provider value={{
            nsuer,
            listToken:data.token,
            block: data.block,
        }}>{children}</web3Context.Provider>
    )
}


const web3Context = createContext<Web3Interface>({
    nsuer: null,
    block: current,
    listToken: {},

})


interface Web3Interface {
    nsuer: Nsuer | any,
    block: number,
    listToken:{[key:string]:BigNumber},


}


export const useWeb3 = () => {
    const {nsuer, block,listToken} = useContext(web3Context);
    return {
        web3: nsuer.web3,
        tokenMap: nsuer.tokenMap,
        changeMap: nsuer.changeMap,
        listToken:listToken,

        contrcts: nsuer.contrcts as Contrcts,
        blockNumber: block,
        walletConnect: nsuer.walletConnect as WalletConnect,

    }
}


async function tokenList(tokenMap: { [key: string]: TokenInterFace }, web3: Web3, account: string) {
    const _map: any = {};
    let _nsure = await tokenMap[NSURE].contract.methods.balanceOf(account).call();
    _map[NSURE] = new BigNumber(_nsure);

    let ethBalance: any = await web3.eth.getBalance(account);
    _map['eth'] = new BigNumber(ethBalance);
    return _map;
}








